function debounce(fn, time) {
  let timeout;
  return function () {
    // eslint-disable-next-line prefer-rest-params
    if (fn) {
      const functionCall = () => fn.apply(this, arguments);
      clearTimeout(timeout);
      timeout = setTimeout(functionCall, time);
    }
  };
}

class RichText extends HTMLElement {
  constructor() {
    super();

    this.trigger = this.querySelector('[data-rich-text-toggle]');
    this.wrapper = this.querySelector('[data-rich-text-content]');

    if (!this.trigger || !this.wrapper) return;

    this.maxHeight = +this.wrapper.dataset.richTextContent;

    // On scroll, observe the product form on mobile and make it fixed when necessary
    this.debouncedOnResize = debounce((event) => {
      this.checkDescription(event);
    }, 500);

    // Check the height for each event
    window.addEventListener('resize',this.debouncedOnResize.bind(this));
    window.addEventListener('load', this.debouncedOnResize.bind(this));

    this.trigger.addEventListener('click', () => {
      const isExpanded = this.ariaExpanded;
      const scrollIntoView = () => {
        this.scrollIntoView({ behavior: 'smooth',
          block: 'start',
          inline: 'nearest' });

        this.wrapper.removeEventListener('transitionend', scrollIntoView);
      };

      this.wrapper.classList.toggle('show_text');
      this.wrapper.addEventListener('transitionend', scrollIntoView);

      if (isExpanded == 'true') {
        this.ariaExpanded = false;
      }
      else {
        this.ariaExpanded = true;
      }
    });

    document.addEventListener('shopify:section:load', () => {
      this.checkDescription();
    });
  }
  checkDescription() {
    this.content = this.querySelector('[data-rich-text]');
    console.dir(this.content);

    // for the description, hide the 'show more' trigger when the height isn't big enough
    const elementHeight = this.content.clientHeight;
    if (this.maxHeight > elementHeight) {
      this.trigger.classList.add('hidden');
      this.wrapper.classList.remove('truncate');
    }
    else {
      this.trigger.classList.remove('hidden');
      this.wrapper.classList.add('truncate');
    }
  }
}
if (!customElements.get('rich-text')) {
  customElements.define('rich-text', RichText);
}